import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Selectors from '../../../selectors'
import { isBrowser, isTablet } from 'react-device-detect'
import { withRouter } from '../../../withRouter'
import { history } from '../../../store'

export class TeamRedirectHandler extends Component {
  componentDidMount() {
    this.handleRedirect(this.props)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.handleRedirect(nextProps)
  }

  handleRedirect(props) {
    const { router } = props
    const isMobile = !isBrowser && !isTablet
    if (router.params.id || isMobile) return
    this.redirect()
  }

  redirect = () => {
    history.push(`/organisation/list`)
  }

  render() {
    return null
  }
}

TeamRedirectHandler.propTypes = {
  selectedUser: PropTypes.string,
}

const mapStateToProps = (state) => ({
  selectedUser: Selectors.chooseSelectedUser(state),
  location: state.global.location,
})

export default connect(mapStateToProps, null)(withRouter(TeamRedirectHandler))
